<script setup>
    import SingleEdit from '@/js/components/Common/SingleEdit.vue'
    import { ref, computed } from 'vue'

    const props = defineProps({
        empfohlenesFachsemester: {
            type: Number,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: () => true
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Program semester module is offered | Empfohlenes Fachsemester' : 'Empfohlenes Fachsemester'
    )

    const emit = defineEmits(['empfohlenesFachsemesterSaved'])

    const editValue = ref('')

    function handleEditStart() {
        editValue.value = props.empfohlenesFachsemester.toString()
    }

    function handleEditAbort() {
        editValue.value = ''
    }

    const saveEmpfohlenesFachsemester = () => {
        emit('empfohlenesFachsemesterSaved', editValue.value)
    }
</script>

<template>
    <single-edit
        :entry="empfohlenesFachsemester.toString()"
        :title="title"
        :allowEdit="allowEdit"
        :tool-tip="tooltip"
        edit-key="empfohlenesFachsemester"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
        @text-saved="saveEmpfohlenesFachsemester"
    >
        <template #edit-component>
            <common-textarea-field v-model="editValue" class="w-100 h-100" />
        </template>
    </single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
